import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconArrowWall2Left: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="square-filled-radius-0-stroke-1.5-IconArrowWall2Left"><Path fillRule="evenodd" clipRule="evenodd" d="M4.5 4V11.6893L9.5 6.68934L10.5607 7.75L7.06067 11.25H21V12.75H7.06065L10.5607 16.25L9.5 17.3107L4.5 12.3106V20H3V4H4.5Z" fill="currentColor"/></CentralIconBase>;
});

export default IconArrowWall2Left;
